export default "__VITE_ASSET__L6_xhSe$__"